// See [Barrel File Removal FAQ](https://hello.atlassian.net/wiki/x/KJT2aAE)
/* eslint-disable no-barrel-files/no-barrel-files */
export const THIRD_PARTY_BANNER_DISMISSED_KEY = 'atlassian.search-ai.3p-banner-dismissed';
